import type { RealtimeHandler } from "../../api/realtimeHandlers";
import { strategyDetailKey, strategyListKey } from "./useStrategies";

/**
 * Strategy hints (`strategy.changed`): the brand's list, and the strategy when
 * it is open. A deleted strategy's detail is dropped rather than refetched.
 */
export const STRATEGY_REALTIME: RealtimeHandler = {
  apply(qc, event) {
    if (event.type !== "strategy.changed") return;
    const { strategyId, action, parts } = event.data;
    void qc.invalidateQueries({ queryKey: strategyListKey(event.brandId) });
    if (action === "deleted") {
      qc.removeQueries({ queryKey: strategyDetailKey(strategyId) });
      return;
    }
    if (action !== "created" || parts.length) {
      void qc.invalidateQueries({ queryKey: strategyDetailKey(strategyId) });
    }
  },

  resyncKeys: (brandId) => [strategyListKey(brandId), ["socialStrategy"]],
};
